import { Link } from "react-router-dom";
import { Route as RouteIcon, X } from "lucide-react";
import { useTripCart } from "@/lib/tripCart";

/**
 * Floating trip tray. Appears on any page as soon as the user has at least 1
 * depot in their trip cart. Tapping it opens the /trip-planner page.
 */
export function TripTray() {
  const { items, clear } = useTripCart();
  if (items.length === 0) return null;

  return (
    <div
      className="fixed bottom-4 right-4 z-[60] flex items-center gap-2 rounded-full bg-amber-500 pl-4 pr-2 py-2 shadow-lg shadow-amber-500/30 border border-amber-400/50"
      data-testid="trip-tray"
    >
      <Link
        to="/trip-planner"
        className="flex items-center gap-2 text-black font-semibold text-sm"
        data-testid="trip-tray-open"
      >
        <RouteIcon className="w-4 h-4" />
        <span className="whitespace-nowrap">
          {items.length} stop{items.length === 1 ? "" : "s"} · Plan Trip
        </span>
      </Link>
      <button
        type="button"
        onClick={clear}
        title="Clear trip"
        className="w-6 h-6 rounded-full bg-black/10 hover:bg-black/25 text-black flex items-center justify-center"
        data-testid="trip-tray-clear"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
